import React from 'react';
import ButtonEdge from '@/presentation/reusables/Button/Edge';
import IconAlert from '../../../../../assets/icons/icon-alert.svg';
import Container from './styled';

const ZoomBindingPrompt = () => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.currentTarget.blur();
    window.open('https://zoom.utp.edu.pe/', '_blank', 'noopener,noreferrer');
  };
  return (
    <Container>
      <div>
        <img src={IconAlert} alt="icon-alert" />
        <p>
          Si tu dispositivo o navegador no está vinculado a Zoom, hazlo ahora.
        </p>
      </div>
      <ButtonEdge buttonType="bindZoom" onClick={handleClick} />
    </Container>
  );
};

export default ZoomBindingPrompt;
